import { Controller } from "@hotwired/stimulus";

export default class extends Controller<HTMLFormElement> {
  clear() {
    this.element.classList.remove("is-invalid");
    const feedbackId = this.element.getAttribute("aria-describedby");
    if (!feedbackId) return;
    const element = document.getElementById(feedbackId);
    element?.classList.add("hidden");
  }
}
